if (!customElements.get('planted-animated-counter')) {
  function formatNumber(number) {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "'")
  }

  class PlantedAnimatedCounter extends HTMLElement {
    connectedCallback() {
      const duration = 1400 // in ms
      const counterEl = this.querySelector('[data-counter-number]')
      const number = parseInt(counterEl.getAttribute('data-counter-number'), 0)

      let startTime
      // ease in out for a smoother animation
      // see https://gizma.com/easing/#easeInOutQuad
      function easeInOutQuad(x) {
        return x < 0.5 ? 2 * x * x : 1 - Math.pow(-2 * x + 2, 2) / 2
      }

      let options = {
        rootMargin: '0px',
        threshold: 1.0
      }

      function animate(time) {
        if (!startTime) {
          startTime = time
        }
        const elapsed = time - startTime
        if (elapsed < duration) {
          const elapsedPercentage = easeInOutQuad(elapsed / duration)
          counterEl.innerText = formatNumber(
            Math.ceil(number * elapsedPercentage)
          )
          window.requestAnimationFrame(animate)
        } else {
          counterEl.innerText = formatNumber(number)
        }
      }

      let observer = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            window.requestAnimationFrame(animate)
            observer.disconnect()
          }
        })
      }, options)
      observer.observe(this)
    }
  }
  customElements.define('planted-animated-counter', PlantedAnimatedCounter)
}
